import React, { Component } from 'react';
import propTypes from 'prop-types';

import { Spinner } from '@tcc/crate';

class ImageWithLoader extends Component {
  constructor(props) {
    super(props);
    this.state = { didLoad: false };
  }

  onLoad() {
    this.setState({
      didLoad: true
    });
  }

  render() {
    const loadingSpinner = !this.state.didLoad ? (
      <Spinner size='24'/>
    ) : null;

    const style = {
      display: this.state.didLoad ? 'initial' : 'none'
    };

    return (
      <div className='vra-image-with-loader__container'>
        <img
          className={this.props.imageClass}
          onLoad={this.onLoad.bind(this)}
          src={this.props.src}
          style={style}
        />
        {loadingSpinner}
      </div>
    );
  }
}

ImageWithLoader.propTypes = {
  imageClass: propTypes.string,
  src: propTypes.string.isRequired
};

export default ImageWithLoader;
